export const STORAGE_KEYS = {
  USER_TOKEN: 'token',
  ORDER_DASHBOARD_LOTS_BY: 'orderDashboardLotsBy',
  USER_LANGUAGE: 'i18nextLng',
}
